import type {ReactElement} from 'react';
import React from 'react';
import {ItemBaseVerticalAlignmentOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-base-vertical-alignment-option';
import type {TextVerticalAlignType} from '@PosterWhiteboard/classes/text-styles.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromSelectedTextSlideItem';

interface TextSlideVerticalAlignmentOptionProps {
  showLargeIcons?: boolean;
  text?: string;
}

export function TextSlideVerticalAlignmentOption({showLargeIcons = false, ...props}: TextSlideVerticalAlignmentOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const verticalAlign = useGetKeyFromSelectedTextSlideItem('verticalAlign');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID) {
    throw new Error('unable to get the selected text slide');
  }

  if (verticalAlign === undefined) {
    throw new Error(`Text Slide doesn't have vertical align property`);
  }

  const onClickHandler = (clickedId: TextVerticalAlignType): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      verticalAlign: clickedId,
    });
  };

  return <ItemBaseVerticalAlignmentOption text={props.text} showLargeIcons={showLargeIcons} selectedAlignment={verticalAlign} onClickAlignmentOption={onClickHandler} />;
}
